<script lang="ts" setup>
import { provide } from 'vue'

const meta = inject('meta', ref())
const { strapiData, strapiError, getStrapiData } = useStrapiCms(meta?.value?.strapi_id, undefined, 'customerServicePage', '', meta?.value?.strapi_locale)
const { $t } = useI18n()

await getStrapiData()

provide('strapiData', strapiData)

const pageTitle = computed(
  () => strapiData.value?.page?.PageTitle || '',
)

const metaTitle = computed(
  () => strapiData.value?.page?.MetaData?.MetaTitle || pageTitle.value + ' | ' + $t('meta.title'),
)

const metaDescription = computed(
  () => strapiData.value?.page?.MetaData?.MetaDescription || $t('meta.description'),
)

const { setBreadcrumbs } = useBreadcrumbs()
setBreadcrumbs({
  label: pageTitle.value,
  parents: meta.value?.parents,
})

const { pageView } = useDataLayer()

if (meta.value?.label === '404') {
  pageView('404', metaTitle.value)
}
else {
  pageView('cms', metaTitle.value)
}

useHead({
  title: metaTitle,
  meta: [
    { name: 'description', content: metaDescription },
    { name: 'robots', content: strapiData.value?.page?.MetaData?.MetaRobots?.replace('_', ', ') },
  ],
  script: [
    { type: 'application/ld+json', key: 'RichSnippets', innerHTML: strapiData.value?.page?.MetaData?.RichSnippets || '' },
  ],
})

const route = useRoute()
const { canonical } = useSeo()
canonical(computed(() => route.path))
</script>

<template>
  <div>
    <UiHeading class="customer-service__heading">
      {{ pageTitle }}
    </UiHeading>

    <UiHeadingSection>
      <div
        v-if="strapiData"
        class="customer-service"
      >
        <!-- Disabled for home -->
        <AppBreadcrumbs v-if="$route.path !== '/'" />

        <StrapiSlices
          v-if="strapiData?.page?.Slices?.length"
          :slices="strapiData.page.Slices"
        >
          <template #before-slice-1>
            <ThirdpartyYouShouldAsk />
          </template>
        </StrapiSlices>
      </div>
    </UiHeadingSection>

    

    <slot />

    <!--  -->
    <!--  -->
  </div>
</template>

<style>
@import url("~layers/pages/~customer-service-overview.css");
</style>
